import { Grid } from "@mui/material";
import AddIcon from '@mui/icons-material/Add'
import React from "react";
import { useNavigate } from "react-router-dom";
import { IsSmallScreen, TransactionPages } from "../../commonFunctions/CommonFunctions";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { Header } from "../../Components/Header/Header";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../Components/DataGrid/WSMobileDataGridAdvanced";
import { WSDadaGridPremium } from "../../Components/DataGrid/WSDadaGridPremium";

export const SurvayList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { edit, add, view } = getPermissions(TransactionPages.Estimates);
  const isMobile = IsSmallScreen();
  const source = {
    url: "Site-Survey-Form/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };

  /**
   *  Edit function
   * @param action
   * @param row
   */
  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/survey/${row?.id}`);
    } else if (action === "Delete") {
    } else if (action === 'Print') {
      navigate(`/estimation/print/${row?.id}`);
    }
    else if (action === 'Convert to Quatation') {
      navigate(`quatation/convert-quatation/${row?.id}`);

    }
  };

  const columns: IColumns[] = [
    {
      header: "Customer Name",
      fieldName: "customerName",
      tooltip: true
    },

    {
      header: "Mobile",
      fieldName: "mobile",
      tooltip: true
    },
    {
      header: "Email",
      fieldName: "email",
      tooltip: true
    },
    {
      header: "Block",
      fieldName: "block",
      tooltip: true
    },

    {
      header: "Panel",
      fieldName: "solarPanel",
      tooltip: true,

    },
    {
      header: "Nos",
      fieldName: "numberOfPanels",
      tooltip: true,

    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined,].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];
  const mobColumns: IOrderColumns[] = [
    {
      header: "Customer Name",
      fieldName: "customerName",
      tooltip: true
    },

    {
      header: "Date",
      fieldName: "date",
      tooltip: true
    },
    {
      header: "Subject",
      fieldName: "subject",
      tooltip: true
    },
    {
      header: "Expiry Date",
      fieldName: "validTill",
      tooltip: true
    },

    {
      header: "Grand Total",
      fieldName: "grandTotal",
      tooltip: true,

    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined, "Convert to Quatation", "Delete", "Print"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];
  const handleClick = () => {
    navigate("/survey");
  };

  return (
    <>
      <Header
        type="card"
        isDivider={true}
        title="Survey"
        id={"surveyHeader"}
        actions={[
          {
            type: 'button',
            label: 'Add new servey',
            icon: <AddIcon />,
            onClick: handleClick,
            color: 'primary',
            variant: 'contained'
          }
        ]}
      />

      {view && <Grid container spacing={2}>
        <Grid item xs={12}>
          {!isMobile && <WSDadaGridPremium
            id="surveyGrid"
            // title="Survey"
            columns={columns}
            source={source}
          // addButton={add ? { label: "New", color: "secondary" } : undefined}
          // onAddButtonClick={handleClick}
          // gridHeaderSx={{
          //   backgroundColor: "whitesmoke",
          //   border: "1px solid whitesmoke"
          // }}
          />}
          {isMobile &&
            <WSMobileDataGridAdvanced title={'Survey'} addButton={add ? { label: "New", color: "secondary" } : undefined}
              onAddButtonClick={handleClick} columns={mobColumns} id="estimationGrid" source={source} />
          }
        </Grid>
      </Grid>}
    </>
  );
});
